import { Injectable } from '@angular/core';
import { LocalStoreManager } from './local-store-manager.service';
import { Utility } from '../../utility';

interface UserConfiguration {
  homeUrl: string | null;
  theme?: string | null;
  showDashboardStatistics?: boolean | null;
  showDashboardNotifications?: boolean | null;
  showDashboardTodo?: boolean | null;
  showDashboardBanner?: boolean | null;
}

@Injectable()
export class ConfigurationService {

  constructor(private localStorage: LocalStoreManager) {
    this.loadLocalChanges();
  }

  set homeUrl(value: string) {
    this._homeUrl = value;
  }

  get homeUrl() {
    if (this._homeUrl != null) {
      return this._homeUrl;
    }
    return ConfigurationService.defaultHomeUrl;
  }

  set theme(value: string | null) {
    this._theme = value;
  }

  get theme() {
    if (this._theme != null) {
      return this._theme;
    }
    return ConfigurationService.defaultTheme;
  }

  public static readonly appVersion: string = '1.0.0';

  // ***Specify default configurations here***
  public static readonly defaultLanguage: string = 'en';
  public static readonly defaultHomeUrl: string = '/';
  public static readonly defaultTheme: string = 'Default';
  public loginUrl = '/login';
  // ***End of defaults***

  // tslint:disable-next-line: variable-name
  private _language: string | null = null;

  // tslint:disable-next-line: variable-name
  private _homeUrl: string | null = null;

  // tslint:disable-next-line: variable-name
  private _theme: string | null = null;

  private loadLocalChanges() { }

  private saveToLocalStore(data: any, key: string) {
    setTimeout(() => this.localStorage.savePermanentData(data, key));
  }

  public import(jsonValue: string | null) {
    this.clearLocalChanges();
    if (!jsonValue) {
      return;
    }
    const importValue: UserConfiguration = Utility.JSonTryParse(jsonValue);
    if (importValue.homeUrl != null) {
      this.homeUrl = importValue.homeUrl;
    }
    if (importValue.theme != null) {
      this.theme = importValue.theme;
    }
  }

  public export(changesOnly = true): string {
    const exportValue: UserConfiguration = {
      homeUrl: changesOnly ? this._homeUrl : this.homeUrl,
      theme: changesOnly ? this._theme : this.theme
    };
    return JSON.stringify(exportValue);
  }

  public clearLocalChanges() {
    this._language = null;
    this._homeUrl = null;
    this._theme = null;
  }

}
